import { FC } from "react";
import Stack from "../components/stack";
import Heading from "../components/heading";
import Body from "../components/body";
import Button from "../components/button";
import YouTubeEmbed from "../components/video";
import Box from "../components/box";

const About: FC = () => {
  return (
    <Box
      localStyles={{
        display: "flex",
        background: "rgba(255,255,255,0.02)",
        borderTop: "1px solid rgba(255,255,255,.2)",
        padding: "var(--scale-72) var(--scale-48)",
        justifyContent: "center",
        alignItems: "center",
        "@media (min-width: 1120px)": {
          padding: "112px 0",
        },
        "@media (min-width: 1600px)": {
          borderTop: "none",
          borderLeft: "1px solid rgba(255,255,255,.2)",
        },
        "@media (min-height: 1060px) and (min-width: 1600px)": {
          height: "100vh",
        },
      }}
    >
      <Stack
        direction="VERTICAL"
        space={"var(--scale-48)"}
        localStyles={{
          maxWidth: 664,
          textAlign: "center",
        }}
      >
        <Heading level="3">FOLLOW RON'S JOURNEY</Heading>
        <YouTubeEmbed videoId="0kcPLRixrFE?si=dadS-PwHi1x3R29B" />
        <Body size="L" weight="BOLD">
          Meet BasementRon, the YouTube star who launched Unicorn Fart Dust on
          the Solana blockchain. This silly coin hit $240 million in value in
          just two days, proving that in the wild world of digital money, even
          the silliest ideas like unicorn farts can become legends.
        </Body>
        <Button
          as="a"
          variant="PRIMARY"
          size="L"
          href="https://www.youtube.com/@ronsbasement"
          target="_blank"
          localStyles={{ maxWidth: 240, alignSelf: "center" }}
        >
          Join the Community
        </Button>
      </Stack>
    </Box>
  );
};

export default About;
